module.exports = __webpack_public_path__ + "static/5-afeaa9428206a5efbecad16eb75d1495.jpg";